/**
 * This is used to mark an input as having a server validation error.
 */
kendo.data.binders.requestError = kendo.data.Binder.extend({
    refresh: function() {
        var msg = this.bindings.requestError.get();
        if (msg) {
            $(this.element).attr("data-df-server-invalid", "true").data("df-server-message", msg);
        }
    }
})